module.exports = __webpack_public_path__ + "static/media/korea-final1.fe18215f.png";